<template>
  <div class="call-user-form">
    <form @submit.prevent="callUser">
      <vi-input
        v-model="phone"
        label="Enter phone number"
        type="text"
        placeholder="+1 xxxx xxx xx"/>
      <div class="actions">
        <ViButton label="Call user"/>
        <ViButton type="button" label="Send Sms" @click="sendSms"/>
      </div>
    </form>
  </div>
</template>

<script>
  import ViInput from "../ui/ViInput";
  import ViButton from "../ui/ViButton";

  export default {
    components: {ViButton, ViInput},

    data: () => ({
      phone: null,
      state: 'initial',
      error: null
    }),

    methods: {
      callUser() {
        this.$emit('call', this.phone)
      },
      sendSms() {
        this.$emit('sms', this.phone)
      }
    }
  }
</script>

<style lang="scss">
  .call-user-form {
    .actions {
      margin-top: 20px;
      text-align: right;

      .vi-button {
        margin-left: 10px;

        &:last-child {
          background: #49914a;
        }
      }
    }
  }
</style>
